import WCovering from './WCovering'

export default WCovering
